import React, { useState } from 'react';
import {
  Button,
  Grid,
  TextField,
} from '@material-ui/core';

import Dialog from '../../ui/Dialog';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import { updateFreeBoxStatusAndDetails } from '../../../services/transaction.service';

const MarkFreeBoxAsProcessing = ({ data }) => {
    const { program_id, transaction_code_id } = data;

  const [state, setState] = useState({
    openConfirmation: false,
    openValidateConfirmation: true,
    modalTitle: 'Mark Free Box As Processing',
    errorMessage: null,
    successMessage: 'Free box has been marked as processing successfully!',
    isLoading: false,
    latestMessage: '',
    messageLogId: null,
    submitButtonEnabled: false,
  });

  const [orderId, setOrderId] = useState('');

  const handleClose = () => {
    const { openConfirmation } = state;
    setState(prev => ({
      ...prev,
      openConfirmation: false,
      openValidateConfirmation: false,
      errorMessage: null
    }));

    if (openConfirmation) {
      window.location.reload();
    }
  };

  const onValidate = async () => {
    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const { message } = await updateFreeBoxStatusAndDetails({
        transaction_code_id,
        connect_program_id: program_id,
        payload: {
          action: 'free-box-processing',
          details: {
            order_id: orderId
          }
        },
      });
      
      setState(prev => ({
        ...prev,
        openValidateConfirmation: false,
        successMessage: message
      }));
    } catch (e) {
      setState(prev => ({
        ...prev,
        errorMessage: e.message
      }));
    } finally {
      setState(prev => ({ ...prev, isLoading: false, openValidateConfirmation: false, openConfirmation: true }));
    }
  };

  const {
    openConfirmation,
    modalTitle,
    errorMessage,
    successMessage,
    isLoading,
    openValidateConfirmation
  } = state;

  if (isLoading) return <LoadingOverlay />;

  const formButtons = (
    <>
      <Button onClick={handleClose} variant="contained">
        {openConfirmation ? 'OK' : 'Close'}
      </Button>
      {
        openValidateConfirmation && 
        <Button
          onClick={onValidate}
          variant="contained"
          color="primary"
          disabled={false}
        >
          Confirm
        </Button>
      }
    </>
  );

  const formContent = (
      <>
        <Grid
          item
          container
          xs={12}
          spacing={2}
        >
          <Grid item xs={12}>
              <TextField
                  label='Order ID'
                  required={true}
                  name='order_id' 
                  variant='outlined'
                  onChange={(e) => setOrderId(e.target && e.target.value)} 
              />
          </Grid>
        </Grid>
      </>
  );

  return (
    <>
      <Dialog
        key="mark-free-box-as-processing"
        open={openValidateConfirmation}
        title={modalTitle}
        content = {formContent}
        children={formButtons}
        onSubmit={onValidate}
        onClose={handleClose}
      />
      <Dialog 
        onSubmit={handleClose}
        key="confirmation"
        open={openConfirmation}
        title='Mark Free Box As Processing'
        content={errorMessage || successMessage}
        children={formButtons}
        onClose={handleClose}
      />
      <Button variant="contained" color="primary" onClick={() => {
         setState(prev => ({
          ...prev,
          openValidateConfirmation: true,
        }));
      }} style={{ marginRight: 8 }}>
        Confirm
      </Button>
    </>
  );
};

export default MarkFreeBoxAsProcessing;